import {Component} from '@angular/core'

@Component({
  selector: 'foa-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'foto-admin-app'
}
